import { Component } from "react";
import Layout from "../../componentes/Comunes/Layout/Layout";
import PageHeading from "../../componentes/Comunes/PageHeading";
import GenerarReporteCrediticio from "../../componentes/InformacionCrediticia/Reporte/GenerarReporteCrediticio";


export class ReporteCrediticio extends Component {

  
  render() {
    return (
      <Layout>
        <div>
          <PageHeading title="Reporte Crediticio" /> 
          <GenerarReporteCrediticio />
        </div>
      </Layout>
    );
  }
}
